import { call, put, takeLatest } from "redux-saga/effects";
import { push } from "connected-react-router";
import { setLocalObj } from "utils/utility/local-storage";
import { loginTypes } from "./constants";
import notify from "utils/notifications";
import LoginService from "./services/login";
import * as actions from "./actions";
import md5 from "md5";
import { replace } from "connected-react-router";

const loginService = new LoginService();

export function* loginWorker(action) {
  try {
    const { user_id, password, shadow_login } = action.payload;
    const reqBody = {
      user_id: user_id,
      password: shadow_login ? password : md5(password),
      shadow_login: shadow_login
    };
    const res = yield call(loginService.loginApi, reqBody);
    if (res.data.status === "success") {
      yield setLocalObj("student-creds", {
        userId: user_id,
        password: password
      });
      yield localStorage.setItem("login-type", "student");
      yield localStorage.removeItem("profile-data");
      const tokenData = res.data.data;
      yield localStorage.setItem("token", tokenData.jwt_token);
      yield localStorage.setItem("admsnNumber", user_id);
      yield setLocalObj("token-data", tokenData);
      yield put(actions.loginSuccess(tokenData));
      if (tokenData.is_independent_student && !tokenData.is_exams_purchased) {
        yield put(push(`/student/exam-selection`));
      } else yield put(push(`/student/home`));
    } else {
      notify("error", res.data.message);
      yield put(actions.loginError(res.data));
    }
  } catch (e) {
    notify("error", "Something went wrong");
    yield put(actions.loginError(e));
  }
}
// eslint-disable-next-line import/no-anonymous-default-export

export function* employeeVerifyWorker(aciton) {
  try {
    const { employee_id } = aciton.payload;
    const reqBody = {
      employee_id: employee_id
    };
    const res = yield call(loginService.employeeVerify, reqBody);
    if (res.status === 200 && res.data.status === "success") {
      yield put(actions.employeeVerifySuccess(res?.data?.data));
      const {
        data: {
          data: { employee_id, mobile_number }
        }
      } = { ...res };
      sessionStorage.setItem("n-otp-sec", 60);
      sessionStorage.setItem("n-screen", "otp");
      sessionStorage.setItem("n-emp-id", employee_id);
      sessionStorage.setItem("n-mob-no", mobile_number);

      yield put(actions.rediectingEmployee(true));
      notify("success", "The OTP is sent successfully.");
    } else {
      yield put(actions.employeeVerifyError(res?.data));
    }
  } catch (error) {
    if (error.response) {
      yield put(
        actions.employeeVerifyError(
          error?.response?.data?.message || "Something went wrong"
        )
      );
    } else {
      yield put(actions.employeeVerifyError(error.message));
    }
  }
}

export function* otpVerifyWorker(action) {
  try {
    const res = yield call(loginService.otpVerify, action.payload);
    if (res.status === 200 && res.data.status === "success") {
      const {
        data: {
          data: {
            tokens: {
              access: { token: access_token },
              refresh: { token: refresh_token }
            }
          }
        }
      } = res;

      localStorage.setItem("token", access_token);
      const registerEmployeeRes = yield call(loginService.registerEmployee);
      if (
        registerEmployeeRes?.status === "success" ||
        registerEmployeeRes?.data?.status === "success"
      ) {
        localStorage.setItem("refresh-token", refresh_token);
        yield put(push({ pathname: `/home` }));
        yield put(actions.rediectingEmployee(false));
      }
    } else {
      actions.otpVerifyError(res.data);
    }
  } catch (error) {
    console.log(error, "errorerror");
    localStorage.clear();
    if (error.response) {
      yield put(
        actions.otpVerifyError(
          error?.response?.data?.message || "Something went wrong"
        )
      );
    } else {
      yield put(actions.otpVerifyError(error.message));
    }
  }
}

export function* otpResendWorker(action) {
  try {
    const { employee_id, callback } = action.payload;
    const res = yield call(loginService.resendOTP, { employee_id });
    if (res.status === 200 && res.data.status === "success") {
      yield put(actions.resendOTPSuccess(res?.data?.data));
      sessionStorage.setItem("n-otp-sec", 60);
      notify("success", "The OTP is sent successfully.");
      callback();
    } else {
      yield put(actions.resendOTPError(res?.data));
    }
  } catch (error) {
    if (error.response) {
      yield put(
        actions.otpVerifyError(
          error?.response?.data?.message || "Something went wrong"
        )
      );
    } else {
      yield put(actions.otpVerifyError(error.message));
    }
  }
}

export function* refreshToken(action) {
  try {
    const reqBody = {};
    const res = yield call(loginService.refreshToken);
  } catch (error) {}
}

export default function* () {
  yield takeLatest(loginTypes.LOGIN_REQUEST, loginWorker);
  yield takeLatest(loginTypes.EMPLOYEE_VERIFY_REQUEST, employeeVerifyWorker);
  yield takeLatest(loginTypes.OTP_VERIFY_REQUEST, otpVerifyWorker);
  yield takeLatest(loginTypes.RESEND_OTP_REQUEST, otpResendWorker);
  yield takeLatest(loginTypes.REFRESH_TOKEN_ERROR, refreshToken);
}
